<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { useVModel } from '@vueuse/core'

const props = withDefaults(
  defineProps<{
    defaultValue?: string
    modelValue?: string
    class?: HTMLAttributes['class']
    invalid?: boolean
    id?: HTMLAttributes['id']
    name?: string
    disabled?: boolean
    placeholder?: string
    maxLength?: number
    autocomplete?: string
  }>(),
  {
    maxLength: 13,
    defaultValue: undefined,
    modelValue: undefined,
    class: undefined,
    id: undefined,
    name: undefined,
    placeholder: undefined,
    autocomplete: undefined
  }
)

const emits = defineEmits<{
  (e: 'update:modelValue', payload: string): void
}>()

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue
})

const onPaste = (event: ClipboardEvent) => {
  event.preventDefault()

  const clipboardData = (
    event.clipboardData?.getData('text/plain') || ''
  ).trim()

  let clipboardValue = clipboardData.replace(/[^\d]+/g, '').trim()

  if (clipboardValue.startsWith('+62'))
    clipboardValue = clipboardValue.replace('+62', '')
  if (clipboardValue.startsWith('62'))
    clipboardValue = clipboardValue.replace('62', '')
  if (clipboardValue.startsWith('0')) clipboardValue = clipboardValue.slice(1)

  return (modelValue.value = clipboardValue.slice(0, props.maxLength))
}
</script>

<template>
  <div class="relative w-full items-center">
    <UiInputField
      :id="props.id"
      v-model="modelValue"
      type="text"
      :invalid="invalid"
      :class="cn('px-11', props.class)"
      inputmode="tel"
      :maxlength="maxLength"
      :name="props.name"
      :disabled="props.disabled"
      :placeholder="props.placeholder"
      :autocomplete="autocomplete"
      @paste="onPaste"
    />
    <span
      class="absolute left-0 inset-y-0 flex items-center justify-center pl-3 text-onSurface peer-data-[invalid=true]:text-error peer-data-[invalid=true]:peer-focus-visible:text-onSurface text-sm font-medium"
    >
      +62
    </span>
    <span
      class="absolute right-0 inset-y-0 flex items-center justify-center pr-2.5 text-primary peer-data-[invalid=true]:text-error peer-data-[invalid=true]:peer-focus-visible:text-primary"
    >
      <Icon name="material-symbols:phone-enabled-outline" size="24px" />
    </span>
  </div>
</template>
